import { DocumentResponse } from '../shared/types/documents';

export const isDocumentImage = (document: DocumentResponse) => {
  return document.mimeType.startsWith('image');
};
